function f(n, r, e) {
  var t = m(n, e.timeZone, e.locale);
  return t.formatToParts ? a(t, r) : o(t, r);
}
function a(n, r) {
  for (var e = n.formatToParts(r), t = e.length - 1; t >= 0; --t)
    if (e[t].type === "timeZoneName")
      return e[t].value;
}
function o(n, r) {
  var e = n.format(r).replace(/\u200E/g, ""), t = / [\w-+ ]+$/.exec(e);
  return t ? t[0].substr(1) : "";
}
function m(n, r, e) {
  if (e && !e.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(e ? [e.code, "en-US"] : void 0, {
    timeZone: r,
    timeZoneName: n
  });
}
export {
  f as default
};
